module.exports = __webpack_public_path__ + "img/fab-check.68fc921a.svg";